export const picklistDefaultValues = {
  picklistProducts: [],
  picklistSupplierCatalogItems: [],
};
